<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid" style="position:relative;height:400px;width:400px; border:1px solid pink">
    <div class="mt-3 pr-0 mr-0">
      <div style="width:100%;overflow:visible;">
        test
          <settingseditor-nested-property class="base-item" v-model="theObject" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="itemSettings" />
      </div>
    </div>
  </div>
</template>

<script>

  
  var theObject = {
    "something": 1,
    "anObject": {},
    "aString": "",
    "aSimpleArray": [1, 2, 3],
    "aComplexArray": [{ something: 1 }, { something: 2 }, { something: 3 }]
  }
  

  //var theObject = [1, 2, 3];

  var documentTypeDefinition = [
    {
      name: "test",
      datatype: "int",
      elements: []
    },
    {
      name: "test1",
      datatype: "string",
      elements: []
    },
    {
      name: "test2",
      datatype: "bool",
      elements: []
    },
    {
      name: "test3",
      datatype: "array",
      arraytype: "int",
      elements: []
    },
    {
      name: "test4",
      datatype: "array",
      arraytype: "test5",
      elements: []
    },
    {
      name: "test5",
      datatype: "object",
      elements: []
    },

  ]

  import NestedProperty from "./settingseditor-nested-property.vue";
  import vuescroll from 'vuescroll';

  export default {
    name: "settingseditor-editmode",
    display: "Nested (v-model & vuex)",
    order: 16,
    components: {
      NestedProperty,
      vuescroll
    },
    props: {

    },
    data() {
      
      return {
        theObject,
        documentTypeDefinition,


        ops: {
          vuescroll: {
            mode: 'slide',
            zooming: false,
          },
          scrollPanel: {
            scrollingY: false
          },
          rail: {
            background: '#F6F7F7',
            opacity: 0.5,
            size: '6px',
            specifyBorderRadius: false,
            gutterOfEnds: null,
            gutterOfSide: '2px',
            keepShow: false
          },
          bar: {
            onlyShowBarOnScroll: false,
            keepShow: true,
            background: '#666767',
          },
          scroller: {
            /*
              Allow to scroll out of boundaries
              true or false or an array specify which direction can be
              bounced. The options can be:
              ['top','bottom','left','right']
            */
            bouncing: false
          }
        }
      };
    },
    computed: {
      Elements: {
        get() {
          var properties = [];
          var propertyNames = Object.keys(this.theObject);
          
          for (var i = 0; i < propertyNames.length; i++) {
            properties.push(this.theObject[propertyNames[i]])
          }
          return properties;
        },
        set(value) {
          /*
          var newObject = {};
          for (var i = 0; i < value.length; i++) {
            newObject[]
          }

          this.procedure.Elements = value;
          */
        }
      }
    },
    methods: {

      saving() {

      },
      itemSettings(element) {
       
      },
      clickItem(element) {
        

      },
      deleteItem(id, elements) {

      },
      handleRefresh(val) {

      },
      loadObject(obj) {

      }
    },
    created() {
     
    },
    mounted() {
      this.loadObject(this.theObject);
    },

    watch: {
    }
  };
</script>


<style scoped>



  .base-item {
    min-height: 100px;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 5px;
    padding-right: 5px;
    border: 2px dashed rgb(122, 176, 197);
    margin-top: 5px !important;
  }

  .drag_container:before {
  }


  .drag_container {
  }
</style>



// WEBPACK FOOTER //
// src/components/settingseditor/settingseditor-editmode.vue